import { Select, type SelectProps } from '@aigc/antd';
import { useQuery } from '@tanstack/react-query';
import type { GetRef } from 'antd';
import type { Ref } from 'react';
import { departmentsQueryOptions } from '../api';

export const DepartmentSelect = (
  props: SelectProps<string> & { ref?: Ref<GetRef<typeof Select>> },
) => {
  const { data, isPending } = useQuery(departmentsQueryOptions);

  return (
    <Select
      {...props}
      loading={isPending}
      options={data?.map((item) => ({ label: item.name, value: item.name }))}
    ></Select>
  );
};
